module.exports = __webpack_public_path__ + "static/media/Frame 2823.dff8264a.jpg";